<h3 *ngIf="!isTicketOpen" class="title is-5">
  {{ 'itinerary-info.segments-info.title' | translate }}
</h3>

<div class="box">
  <div class="columns is-centered">
    <div class="column is-narrow">
      <span class="icon is-large is-danger">
        <em *ngIf="!isTicketOpen" class="mdi mdi-48px mdi-alert"></em>
        <em *ngIf="isTicketOpen" class="mdi mdi-48px mdi-calendar-blank "></em>
      </span>
    </div>
  </div>
  <div class="columns is-centered">
    <div class="column is-narrow is-paddingless">
      <h3 class="title is-5">
        {{
          (isTicketOpen
            ? 'itinerary-info.open-ticket.title'
            : 'itinerary-info.discharged-itinerary.title'
          ) | translate
        }}
      </h3>
    </div>
  </div>
  <div class="columns is-centered">
    <div class="column is-5 is-narrow has-text-centered">
      <span class="is-size-7">
        {{
          (isTicketOpen
            ? 'itinerary-info.open-ticket.subtitle'
            : 'itinerary-info.discharged-itinerary.subtitle'
          ) | translate
        }}
      </span>
    </div>
  </div>
</div>
